import { JSX } from "solid-js";

/**
 * Popular Brands Header
 * Centered "POPULAR BRANDS" text with horizontal divider lines
 */
export function PopularBrandsHeader(): JSX.Element {
  return (
    <div class="flex w-full max-w-[1024px] items-center justify-center gap-4 px-3 pt-7 sm:px-0">
      {/* Left Divider */}
      <div class="h-[1px] flex-1 bg-stroke-1" />

      {/* Text */}
      <p class="shrink-0 text-center  text-caption-semi-bold uppercase text-text-normal-secondary">
        Popular Brands
      </p>

      {/* Right Divider */}
      <div class="h-[1px] flex-1 bg-stroke-1" />
    </div>
  );
}
